/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chot_So_HelperInputs */

const vi_chot_so_helper = /** @type {(inputs: Chot_So_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo phiếu kiểm kê tồn kho tại thời điểm hôm nay để đối chiếu`)
};

/**

* @param {Chot_So_HelperInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const chot_so_helper = /** @type {((inputs?: Chot_So_HelperInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chot_So_HelperInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_chot_so_helper(inputs)
});